import type {
  CardToken,
  CardTokenRequestor,
  CardTokenStatus,
} from '@/integrations/Immersve/card-tokens/types';

const REQUESTOR_LABELS: Record<CardTokenRequestor, string> = {
  'apple-pay': 'Apple Pay',
  'google-pay': 'Google Pay',
  'samsung-pay': 'Samsung Pay',
  merchant: 'Merchant',
  other: 'Other',
};

const STATUS_TONES = {
  green: 'bg-green-50 text-green-700 ring-green-600/20',
  amber: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  orange: 'bg-orange-50 text-orange-700 ring-orange-600/20',
  // A shade lighter than orange: on its way to suspended, not there yet.
  lightOrange: 'bg-orange-50/60 text-orange-600 ring-orange-500/20',
  gray: 'bg-gray-50 text-gray-600 ring-gray-500/20',
  blue: 'bg-blue-50 text-blue-700 ring-blue-600/20',
};

// The -ing statuses are transitions still in flight. Suspending takes a
// lighter suspended tone; the rest share blue.
export const STATUS_TONE_CLASSES: Record<CardTokenStatus, string> = {
  active: STATUS_TONES.green,
  'awaiting-approval': STATUS_TONES.amber,
  'awaiting-verification': STATUS_TONES.amber,
  suspended: STATUS_TONES.orange,
  canceled: STATUS_TONES.gray,
  creating: STATUS_TONES.blue,
  approving: STATUS_TONES.blue,
  suspending: STATUS_TONES.lightOrange,
  unsuspending: STATUS_TONES.blue,
  canceling: STATUS_TONES.blue,
};

export function requestorLabel(token: Pick<CardToken, 'requestor'>): string {
  return REQUESTOR_LABELS[token.requestor] ?? token.requestor;
}

export function statusLabel(token: CardToken): string {
  return token.status.replace('-', ' ');
}
